import React from 'react';
import { MdVisibility } from 'react-icons/md';
import KPICard from './KPICard';
import { Measurement } from '../services/measurementService';
import './MeasurementHeader.css';

interface MeasurementHeaderProps {
  measurement: Measurement;
}

const MeasurementHeader: React.FC<MeasurementHeaderProps> = ({ measurement }) => {
  // Format date helper
  const formatDate = (dateString: string): string => {
    try {
      return new Date(dateString).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });
    } catch {
      return dateString;
    }
  };

  // Format numbers for display
  const formatImpressions = (value?: number | null): string => {
    if (value === null || value === undefined) return '-';
    if (value >= 1000000) {
      return `${(value / 1000000).toFixed(1)}M`;
    }
    if (value >= 1000) {
      return `${(value / 1000).toFixed(1)}K`;
    }
    return value.toString();
  };

  return (
    <div className="measurement-header">
      <div className="measurement-header-info">
        <h1 className="measurement-name">{measurement.name}</h1>
        <div className="measurement-meta">
          <span className="measurement-advertiser">{measurement.advertiser}</span>
          {measurement.brand && (
            <>
              <span className="meta-separator">•</span>
              <span className="measurement-brand">{measurement.brand}</span>
            </>
          )}
        </div>
        <div className="measurement-dates">
          <span>
            {formatDate(measurement.startDate)} - {formatDate(measurement.endDate)}
          </span>
        </div>
      </div>
      
      <div className="measurement-header-kpis">
        <KPICard
          icon={MdVisibility}
          headline="IMPRESSIONS"
          value={formatImpressions(measurement.impressions)}
        />
        {/* <KPICard
          icon={MdGroup}
          headline="REACH"
          value={formatReach(measurement.reach)}
        />
        <KPICard
          icon={MdAutorenew}
          headline="AVG. FREQUENCY"
          value={formatFrequency(measurement.frequency)}
        /> */}
      </div>
    </div>
  );
};

export default MeasurementHeader;
